<template>
    <glm-layout margin-footer>
        <world-map :specials="$page.props.mapCountries" height="200px">
            <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 flex items-center h-full justify-start">
                <div class="rounded-md max-w-lg inline-block p-2 bg-grey-700 text-white mt-3">
                    <h1 class="font-bold font-serif text-3xl">
                        The Team
                    </h1>
                </div>
            </div>
        </world-map>

        <page-content class="mt-12">
            <div class="mb-8 text-sm shadow-sm rounded flex items-stretch justify-start">
                <div class="p-2 bg-glm-blue text-blue-100 flex items-center justify-center rounded-l">
                    <font-awesome-icon
                        :icon="['fad', 'info']"
                        class="fa-fw"
                        size="lg"
                    ></font-awesome-icon>
                </div>

                <p class="p-2 bg-blue-100 text-glm-blue flex-1 rounded-r">
                    Please contact us via the following email address <a class="underline" href="mailto:jwp@iza.org">jwp@iza.org</a>.
                </p>
            </div>

            <h4 class="text-3xl font-serif font-bold mb-12 text-glm-black md:text-center">Project Lead</h4>

            <div class="flex flex-col">
                <member v-for="(member, idx) in research" :key="idx" :member="member" :idx="idx" />
            </div>

            <h4 class="text-3xl font-serif font-bold mb-12 text-glm-black md:text-center">Data Crew</h4>

            <div class="flex flex-col">
                <member v-for="(member, idx) in dataCrew" :key="idx" :member="member" :idx="idx" />
            </div>

            <h4 class="text-3xl font-serif font-bold mb-12 text-glm-black md:text-center">Website Design</h4>

            <div class="flex flex-col">
                <member v-for="(member, idx) in webDesign" :key="idx" :member="member" :idx="idx+1" />
            </div>
        </page-content>
    </glm-layout>
</template>

<script>
import NavBar from '@/Components/NavBar'
import GlmLayout from '@/Layouts/GlmLayout'
import WorldMap from '@/Components/WorldMap'
import PageContent from '@/Components/PageContent'
import Member from '@/Components/Member'

export default {
    components: {
        Member,
        PageContent,
        WorldMap,
        GlmLayout,
        NavBar,
    },

    data () {
        return {
            research: [
                {
                    name       : 'Oriana Bandiera',
                    description: 'Oriana Bandiera is the Sir Anthony Atkinson Professor of Economics at the London School of Economics, and a fellow of the British Academy, the Econometric Society, CEPR, BREAD and IZA.',
                    website    : 'https://www.lse.ac.uk/economics/people/faculty/oriana-bandiera',
                    picture    : '/files/bandiera.png',
                },
                {
                    name       : 'Ahmed Elsayed',
                    description: 'Ahmed Elsayed is an Associate Professor at the American University in Cairo (AUC) and the Director of J-PAL MENA at AUC. He is a Research Fellow at the IZA, ROA in Maastricht University, and the Economic Research Forum (ERF) in Cairo, Egypt.',
                    website    : 'https://www.iza.org/people/staff/8722/ahmed-elsayed',
                    picture    : '/files/elsayed.jpg',
                },
            ],

            dataCrew: [
                {
                    name       : 'Gabriela Díaz-Pardo',
                    description: 'Gabriela Díaz is a Pre-Doctoral Research Assistant at the London School of Economics. She oversees the assembly, maintenance, and updating of the JWD dataset.',
                    website    : 'https://www.hubequalrep.org/our-team/',
                    picture    : '/files/diaz-pardo.png',
                },
                {
                    name       : 'Gabriel Leite Mariante',
                    description: 'Gabriel is a PhD candidate at the London School of Economics. His main fields of interest are empirical Development and Public Economics. ',
                    website    : 'https://www.lse.ac.uk/economics/people/research-students/gabriel-leite-mariante',
                    picture    : '/files/mariante.jpg',
                },
                {
                    name       : 'Andrea Smurra',
                    description: 'Andrea Smurra is a PhD candidate at University College London, and a PhD Fellow at the Institute for Fiscal Studies. ',
                    website    : 'https://www.andreasmurra.com/',
                    picture    : '/files/smurra.jpg',
                },
                {
                    name       : 'Caterina Soto-Vieira',
                    description: 'Caterina is PhD candidate at the London School of Economics. Her main areas of interest are Development Economics, Labour Economics, and Urban Economics',
                    website    : 'https://www.lse.ac.uk/economics/people/research-students/caterina-soto-vieira',
                    picture    : '/files/vieira.jpg',
                },
                {
                    name       : 'Céline Zipfel',
                    description: 'Céline is an Assistant Professor at the Department of Economics at the Stockholm School of Economics.',
                    website    : 'https://sites.google.com/view/celinezipfel/home',
                    picture    : '/files/zipfel.jpg',
                },
            ],

            webDesign: [
                {
                    name       : 'IZA – Institute of Labor Economics',
                    description: 'Technical implementation by the Institute of Labor Economics (IZA).',
                    website    : 'https://www.iza.org',
                    picture    : '',
                },
            ],
        }
    },
}
</script>
